import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByIndex} from "../charts/DashBoardResultSetUtil";
import {prepareChartData} from "./HighChartsDrawer";
import {isEnglish} from "../../common/Translator";

export function calcChartTitle(dashboardChartLine) {
    if (isEnglish())
        return dashboardChartLine.enChartTitle;
    return dashboardChartLine.arChartTitle;
}

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHighGauge(userDashboardChartLine, h, w, widget, Highcharts) {
    let parameters = userDashboardChartLine.parameters;
    let chartTitle = calcChartTitle(userDashboardChartLine);
    let gaugeUnit = parameters[DashboardConstants.Param_GuageUnit];
    let gaugeBands = parameters[DashboardConstants.Param_GaugeBands];
    let values = userDashboardChartLine.resultSet;
    let split = gaugeBands.split(",");
    let min = 0;
    let max = 0;
    let bands = [];
    for (let i = 0; i < split.length; i += 3) {
        let from = parseInt(split[i]);
        if (from < min)
            min = from;
        let to = parseInt(split[i + 1]);
        if (to > max)
            max = to;
        let color = split[i + 2];
        bands.push({
            from: from,
            to: to,
            color: color
        });
    }
    let data = [];
    data.push(parseFloat(getByIndex(0, 0, values)));
    let widgetId = widget.attr('id');
    let chartData = {
        type: 'gauge',
    };
    chartData = prepareChartData(chartData, w, h);
    Highcharts.chart(widgetId, {
        title: {
            text: chartTitle
        },
        chart: chartData,
        pane: {
            startAngle: -150,
            endAngle: 150,

        },
        series: [{
            data: data,
            tooltip: {
                valueSuffix: gaugeUnit,
                useHTML: true
            }
        }],
        yAxis: {
            min: min,
            max: max,
            minorTickInterval: 'auto',
            minorTickWidth: 1,
            minorTickLength: 10,
            minorTickPosition: 'inside',
            minorTickColor: '#666',

            tickPixelInterval: 30,
            tickWidth: 2,
            tickPosition: 'inside',
            tickLength: 10,
            tickColor: '#666',
            labels: {
                step: 2,
                rotation: 'auto'
            },
            plotBands: bands,
            title: {
                text: gaugeUnit
            },
        }
    });
}